import React from 'react'
import { motion } from "framer-motion";
import aboutImg from './images/aboutImg.jpeg'
import ExpandableText from './components/TextExtand';
import { useState,useEffect } from 'react';
import { SlDiamond } from "react-icons/sl";
import DutyCardList from './modals/DutyCard';
import { FaUserGroup } from "react-icons/fa6";
import { AiOutlineBulb } from "react-icons/ai";
import { LuHandshake } from "react-icons/lu";
import { GrTarget } from "react-icons/gr";
import { GoShieldCheck } from "react-icons/go";
import LeaderCardList from './modals/LeaderCard';
const AboutPage = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); 
      };
  
      handleResize(); 
      window.addEventListener("resize", handleResize);
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
      };

      const DutyCards=[
        {
            title: "کیفیت",
         
            desc: "تعهد ما به ارائه خدمات با بالاترین کیفیت، ستون اصلی فعالیت بارسرا است.",
            icon: <SlDiamond></SlDiamond> ,
          },
          {
            title: "مشتری مداری",
         
            desc: "رضایت مشتری در اولویت است و ما برای درک و رفع نیازهای آنها تلاش می‌کنیم.",
            icon: <FaUserGroup></FaUserGroup> ,
          },
          {
            title: "نوآوری",
         
            desc: "ما همیشه به دنبال راه‌حل‌های خلاقانه و نوآورانه برای چالش‌ها هستیم.",
            icon: <AiOutlineBulb></AiOutlineBulb> ,
          },
          {
            title: "مسیولیت پذیری",
         
            desc: "ما نسبت به تعهدات خود مسئولیت‌پذیریم و به نتایج کارهایمان افتخار می‌کنیم.",
            icon: <GrTarget></GrTarget> ,
          },
          {
            title: "همکاری",
         
            desc:"ما باور داریم که بهترین نتایج از طریق همکاری و کار تیمی به دست می‌آید.",
            icon: <LuHandshake></LuHandshake> ,
          },
          {
            title: "شفافیت",
         
            desc: "اعتماد با شفافیت ساخته می‌شود؛ ما در تمام مراحل صادق و صریح هستیم.",
            icon: <GoShieldCheck></GoShieldCheck> ,
          },
         
      ]

      const LeaderCards=[
        {
            title: "فاطمه کریمی",
         
            desc: "مدیر عامل",

          },
          {
            title: "فاطمه کریمی",
         
            desc: "مدیر عامل",
 
          },
          {
            title: "فاطمه کریمی",
         
            desc: "مدیر عامل",

          },

       
      
      ]



  return (
    <>
    <div className="w-full flex flex-col gap-10 min-h-screen py-10">
        
        {/* header */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex  flex-col bg-blue_light mt-6 lg:flex-row lg:justify-start items-center shadow-md  gap-10 lg:gap-16 rounded-2xl py-6 lg:py-10 px-4 sm:px-5 lg:px-10"
        >
          <div className="flex w-full lg:w-max  justify-center lg:justify-start">
            <img
              src={aboutImg}
              alt="بارسرا"
              className="w-full max-w-sm lg:max-w-[500px] rounded-xl object-contain"
            />
          </div>

          <div className="flex w-full lg:w-1/2 justify-center  lg:justify-start lg:text-start lg:items-start font-inter">

            <motion.div
              variants={fadeUp}
              initial="hidden"
              animate="show"
              transition={{ delay: 0.2 }}
              className="flex flex-col items-center justify-between text-start gap-6  max-w-sm lg:min-w-full"
            >
              <div className="flex flex-col gap-2 w-full">
                <p className="text-[14px]  lg:text-[18px] font-extrabold text-blue-950">
                درباره ما: بارسرا
                </p>
              </div>

              <p className="text-[13px] sm:text-[14px] lg:text-[16px] font-light text-special leading-relaxed">
              بارسرا یک شرکت پیشرو در زمینه ارائه راه‌حل‌های نوآورانه برای کسب‌وکارها است. ما با تیمی متخصص و متعهد، در تلاشیم تا با ارائه خدماتی بی‌نظیر، به رشد و موفقیت شرکای تجاری خود کمک کنیم. از زمان تأسیس، هدف ما ایجاد ارزش پایدار و پایه‌گذاری روابطی مبتنی بر اعتماد و همکاری بوده است.
              </p>
            </motion.div>

          </div>

        </motion.div>

  {/* about textes */}
         <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center gap-10 justify-between lg:px-10 px-5 w-full  mt-5 lg:py-10 py-6 rounded-2xl"
        >
                <p className="lg:text-[22px] text-[18px] text-special font-bold">
                    تاریخچه بارسرا
                </p>

                <div className="w-full flex flex-col gap-10 lg:px-40 px-5">

                    {
                        isMobile?
                        <ExpandableText className={"lg:hidden"} text={"بارسرا در سال [سال_تأسیس] با هدف تحول در [صنعت_مورد_نظر] تأسیس شد. در ابتدا، ما فعالیت خود را با تیمی کوچک اما پرشور آغاز کردیم و به سرعت توانستیم جایگاه خود را در بازار تثبیت کنیم. تمرکز اولیه ما بر روی [خدمت_اولیه] بود."}></ExpandableText>
                        :
                        <p className='lg:text-[16px] text-[14px] leading-[30px]'>
                            بارسرا در سال [سال_تأسیس] با هدف تحول در [صنعت_مورد_نظر] تأسیس شد. در ابتدا، ما فعالیت خود را با تیمی کوچک اما پرشور آغاز کردیم و به سرعت توانستیم جایگاه خود را در بازار تثبیت کنیم. تمرکز اولیه ما بر روی [خدمت_اولیه] بود.
                        </p>

                    }
                    {
                        isMobile?
                        <ExpandableText className={"lg:hidden"} text={"در طول سال‌ها، با گسترش دامنه خدمات و افزایش تعداد مشتریان وفادار، بارسرا به یکی از نام‌های قابل اعتماد در [صنعت_مورد_نظر] تبدیل شد. نقاط عطف مهمی شامل [دستاورد ۱] در سال [سال] و [دستاورد ۲] در سال [سال] مسیر رشد ما را پررنگ‌تر ساخت. ما همواره در حال یادگیری و انطباق با تغییرات بازار هستیم."}></ExpandableText>
                        :
                        <p className='lg:text-[16px] text-[14px] leading-[30px]'>
                        در طول سال‌ها، با گسترش دامنه خدمات و افزایش تعداد مشتریان وفادار، بارسرا به یکی از نام‌های قابل اعتماد در [صنعت_مورد_نظر] تبدیل شد. نقاط عطف مهمی شامل [دستاورد ۱] در سال [سال] و [دستاورد ۲] در سال [سال] مسیر رشد ما را پررنگ‌تر ساخت. ما همواره در حال یادگیری و انطباق با تغییرات بازار هستیم.
                        </p>

                    }
                    {
                        isMobile?
                        <ExpandableText className={"lg:hidden"} text={"امروز، بارسرا با افتخار به گذشته خود نگاه می‌کند و با چشم‌اندازی روشن به آینده، به نوآوری و ارائه بهترین‌ها ادامه می‌دهد. ما متعهدیم که همواره در کنار مشتریان خود باشیم و به آنها در رسیدن به اهدافشان کمک کنیم."}></ExpandableText>
                        :
                        <p className='lg:text-[16px] text-[14px] leading-[30px]'>
                        امروز، بارسرا با افتخار به گذشته خود نگاه می‌کند و با چشم‌اندازی روشن به آینده، به نوآوری و ارائه بهترین‌ها ادامه می‌دهد. ما متعهدیم که همواره در کنار مشتریان خود باشیم و به آنها در رسیدن به اهدافشان کمک کنیم.
                        </p>
                

                    }



                
            
                </div>
        </motion.div>

    {/* خدمات */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center bg-[#F6F6F6] gap-10 justify-between lg:px-10 px-5 w-full  mt-5 lg:py-10 py-6 rounded-2xl"
        >
                <p className="lg:text-[22px] text-[18px] text-special font-bold">
                ماموریت و ارزش های ما
                </p>

               <DutyCardList items={DutyCards}></DutyCardList>
        </motion.div>

        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="flex flex-col items-center bg-white gap-10 justify-between lg:px-10 px-5 w-full  mt-5 lg:py-10 py-6 rounded-2xl"
        >
                <p className="lg:text-[22px] text-[18px] text-special font-bold">
               تیم رهبری بارسرا
                </p>

               <LeaderCardList items={LeaderCards}></LeaderCardList >
        </motion.div>




    </div>
            <div className="flex flex-col h-auto py-10 justify-between px-6 sm:px-10 lg:px-20 pt-5 w-full bg-white shadow-sm border-t border-gray-200 divide-y divide-gray-200">

            <div className="w-full h-full flex flex-col lg:flex-row justify-between gap-8 lg:gap-0 pb-6">
                {/* معرفی */}
                <div className="w-full lg:w-1/2 flex flex-col lg:items-start  text-center items-center lg:text-center gap-4">
                <p className=" text-lg sm:text-md lg:text-lg text-start">پشتیبانی جامع</p>
                <p className="text-xs sm:text-sm font-medium leading-relaxed w-3/4 text-gray-600">
                  ما به پشتیبانی کامل و مستمر از مشتریان خود افتخار می‌کنیم. از اولین تماس تا اتمام پروژه و پس از آن، تیم ما همیشه آماده پاسخگویی به سوالات و رفع نیازهای شماست تا تجربه‌ای بی‌نظیر را برایتان رقم بزند. ما در هر مرحله کنار شما هستیم.                </p>
                </div>

                <div className="w-full lg:w-1/2 flex flex-col lg:items-start  text-center items-center lg:text-center gap-4">
                <p className=" text-lg sm:text-md lg:text-lg text-start">تجربه  و تخصص</p>
                <p className="text-xs sm:text-sm font-medium leading-relaxed w-3/4 text-gray-600">
                با سال‌ها تجربه در [نام_صنعت]، تیم ما متشکل از متخصصانی است که دانش و مهارت‌های لازم برای ارائه بهترین خدمات را دارند. ما به دقت در جزئیات و ارائه راه‌حل‌های سفارشی برای هر مشتری اعتقاد داریم تا نیازهای خاص شما را برآورده کنیم.                      </p>
                </div>
            </div>

            
        </div>
    </>
    
  )
}

export default AboutPage
